import camelcase from 'camelcase';
import { mapValues } from 'lodash-es';

const LDFlags = {
  CartUpsell: 'cart-upsell',
  CovidCoreCheckout: 'covid-core-checkout',
  CovidPIPCategory: 'covid-pip-category',
  CovidQtyAndScreener: 'covid-quantity-select-and-skip-eligibility',
  ExpressShipping: 'express-shipping',
  VitaminsWork: 'vitamins-work',
  HomepageCarousel: 'homepage-carousel',
};

export const Flags = mapValues(LDFlags, (flag) => camelcase(flag));
